import { AtlasV2RatingsPageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasV2RatingsPageLayout';
import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';

export default function getAtlasV2RatingPageLayout() {
  return {
    CustomPageContainer: GenericPageContainer,
    enableComparison: false,
    widgets: [
      {
        name: 'keyMetricsPageLayout',
        CustomComponent: AtlasV2RatingsPageLayout,
        view: {}
      }
    ],
    containerStyle: {},
    dataConfig: {}
  };
}
